import {
  AdditionalInterestValidationBlockReason,
  useValidatePolicyForAdditionalInterestQuery,
} from "@covertree/agent-portal-graphql";
import { featureFlags } from "@utils/featureFlags";
import { useAccessPattern } from "@hooks/useAccessPattern";
import type { PolicyDetailsContentProps } from "../../types";

export function useAdditionalInterests(
  policy: PolicyDetailsContentProps["policy"]
) {
  const mutationFeatureFlagEnabled =
    featureFlags.newAdditionalInterestTabEnabled.isEnabled();
  const { canManageAdditionalInterests } = useAccessPattern();

  const {
    loading: isValidationLoading,
    data,
    error: generalValidationError,
  } = useValidatePolicyForAdditionalInterestQuery({
    variables: { policyLocator: policy?.policyLocator },
    skip:
      !mutationFeatureFlagEnabled ||
      !policy?.policyLocator ||
      !canManageAdditionalInterests,
    notifyOnNetworkStatusChange: true,
  });

  const validationReason =
    data?.validatePolicyForAdditionalInterest?.reason ?? null;
  const additionalInterests = policy?.additionalInterests ?? [];

  const shouldDisableManage =
    !mutationFeatureFlagEnabled ||
    validationReason ===
      AdditionalInterestValidationBlockReason.PolicyExpired ||
    !canManageAdditionalInterests;

  return {
    validationReason,
    additionalInterests,
    isValidationLoading,
    generalValidationError,
    shouldDisableManage,
    mutationFeatureFlagEnabled,
  };
}
